<div class="card">
    <div class="card_body">
        <form class="form">
            <div class="form_group">
                <label class="row inp_group row_ai_center">
                    <div class="col-5 lbl lbl_mb_0">Создан</div>
                    <div class="row row_inp row_ai_center col-19 fz_s">
                        <div class="skeleton_container" *ngIf="isLoading" style="width: 40%;"><app-skeleton height="17"></app-skeleton>
                        </div>
                        {{dateFormatterPipe.transform(order.createdAt, 'yyyy-MM-dd HH:mm:ss')}}
                    </div>
                </label>
                <label class="row inp_group row_ai_center">
                    <div class="col-5 lbl lbl_mb_0">Сумма</div>
                    <div class="row row_inp row_ai_center col-19 fz_s">
                        <div class="skeleton_container" *ngIf="isLoading" style="width: 40%;"><app-skeleton height="17"></app-skeleton></div>
                        {{order.currency == 'usd' ? '$' : '€'}}{{order.total}}
                    </div>  
                </label>
                <label class="row inp_group row_ai_center">
                    <div class="col-5 lbl lbl_mb_0">Имя</div>
                    <div class="row row_inp col-19">
                        <input type="text" class="inp" placeholder="John" (input)="changeOrderInfo('firstname')" [(ngModel)]="orderForm.firstname" name="firstname">
                        <input type="text" class="inp" placeholder="Doe" (input)="changeOrderInfo('lastname')" [(ngModel)]="orderForm.lastname" name="lastname">
                    </div>
                </label>
                <label class="row inp_group row_ai_center">
                    <div class="col-5 lbl lbl_mb_0">Телефон</div>
                    <div class="col-19">
                        <app-input-tel name="phone" (changeCustomerPhone)="changeOrderInfo('phone')" [phoneValue]="orderForm.phone" [phoneCode]="orderForm.phone?.[0]" (phoneValueChange)="orderForm.phone = $event"></app-input-tel>
                    </div>
                </label>
                <label class="row inp_group row_ai_center">
                    <div class="col-5 lbl lbl_mb_0">Имейл</div>
                    <div class="col-19"><input type="email" placeholder="example@example.com" (input)="changeOrderInfo('email')" [(ngModel)]="orderForm.email" class="inp" name="email"></div>
                </label>
                <label  class="row inp_group row_ai_center">
                    <div class="col-5 lbl lbl_mb_0">Адрес</div>
                    <div class="col-19"><input type="text" placeholder="99 Wall Street, #5553, New York, NY, 10005" class="inp" name="address" (input)="changeOrderInfo('address')" [(ngModel)]="customerAddress.street"></div>
                </label>
            </div>
            <div *ngIf="btnsVisible" class="btns_container row fw_500 fz_s">
                <button (click)="resetForm()" class="btn btn_cancel">Очистить</button>
                <button (click)="updateOrder()" [disabled]="isLoadingSend" class="btn dark_btn row"><span *ngIf="isLoadingSend" class="loader"></span> <span *ngIf="!isLoadingSend">Сохранить</span></button>
            </div>
            <div *ngIf="restoreBtnVisible" class="btns_container row fw_500 fz_s">
                <button (click)="restoreForm()" class="btn dark_btn">Вернуть</button>
            </div>
        </form>
    </div>
</div>